import React from 'react'
// libs
import { Field } from 'redux-form'
// components
import { WrappedFieldProps } from 'redux-form/lib/Field'
import { SketchPickerProps } from 'react-color/lib/components/sketch/Sketch'
import { ColorResult, SketchPicker } from 'react-color'

interface Props extends Omit<SketchPickerProps, 'height' | 'ref' | 'onChange'> {
  name: string
  onChange?: (color: any) => void
  initialColor?: string
}

const renderComponent = ({ input, onChange, initialColor, ...rest }: Props & WrappedFieldProps) => {
  const onChangeComplete = (color: ColorResult) => {
    input.onChange(color.hex)
    onChange?.(color.hex)
  }

  return <SketchPicker color={input.value || initialColor} onChangeComplete={onChangeComplete} {...rest} />
}

const ReduxColorSelect: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxColorSelect
